<template>
    <div class="FamilyPane">
        <div class="container-fluid container-fill">
            <div class="row">
                <div class="col-lg-3 col-xl-2">
                    <div class="paper olive-green">
                        <b-nav pills vertical class="side-menu">
                            <b-nav-item v-on:click="ChangePaneShown('AddFamily')" v-bind:class="{ active: PanesShown == 'AddFamily' }"><font-awesome-icon :icon="['fa', 'plus']" /> Add Family</b-nav-item>
                            <b-nav-item v-on:click="ChangePaneShown('Families')" v-bind:class="{ active: PanesShown == 'Families' }"><font-awesome-icon :icon="['fa', 'list']" /> Families</b-nav-item>
                            <b-nav-item v-for="(familyRecord, familyID) in OpenFamilyRecords" v-if="familyRecord.hasOwnProperty('Family')" v-bind:class="{ active: PanesShown == familyID }">
                                <span v-on:click="ChangePaneShown(familyID)">
                                    <font-awesome-icon :icon="['fa', 'home']" />
                                    {{ familyRecord.Family.Name }}
                                </span>
                                <span style="float:right" v-on:click="CloseFamilyRecord(familyID)">X</span>
                            </b-nav-item>
                        </b-nav>
                    </div>
                </div>
                <div class="col-lg-9 col-xl-10">
                    <div class="paper">
                        <div class="tab-content col-12">
                            <div v-show="PanesShown == 'AddFamily'">
                                <AddNewFamily />
                            </div>
                            <div v-show="PanesShown == 'Families'">
                                <FamilyList />
                            </div>
                            <div v-for="(familyRecord, familyID) in OpenFamilyRecords" v-if="familyRecord.hasOwnProperty('FamilyProgramMembership')" v-show="PanesShown == familyID">
                                <FamilyRecord v-bind:family-record-data="familyRecord" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    //import icons
    import { library } from '@fortawesome/fontawesome-svg-core';
    import { faPlus } from '@fortawesome/free-solid-svg-icons';
    library.add(faPlus);
    import { faList } from '@fortawesome/free-solid-svg-icons';
    library.add(faList);
    import { faHome } from '@fortawesome/free-solid-svg-icons';
    library.add(faHome);
    //import components
    import FamilyList from "./FamilyList.vue";
    import AddNewFamily from "./AddNewFamily.vue";
    import FamilyRecord from "./FamilyRecord/FamilyRecord.vue";

    export default {
        props: [],
        data: function () {
            return {
                PanesShown: "Families"
            };
        },
        methods: {
            ChangePaneShown(paneName) {
                //loop through Panes shown and flip true/false values
                this.PanesShown = paneName;
            },
            CloseFamilyRecord: function (familyID) {
                if (this.PanesShown == familyID) {
                    this.ChangePaneShown("Families");
                }
                this.$store.commit("Families.FamilyProfiles.Remove", familyID);

            }
        },
        computed: {
            OpenFamilyRecords() {
                return this.$store.state.Families.FamilyProfiles;
            }
        },
        components: {
            FamilyList,
            AddNewFamily,
            FamilyRecord
        }
    }
</script>

<style scoped>
</style>